import { render, staticRenderFns } from "./DataSourceEdit.vue?vue&type=template&id=b4364c5c&"
import script from "./DataSourceEdit.vue?vue&type=script&lang=js&"
export * from "./DataSourceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports